import { useFiltersBufferState, useFiltersV2Actions, useFiltersV2Select } from "PFApp/components/filters_v2";
import { Button } from "PFComponents/button";
import { useTranslation } from "react-i18next";

export const FiltersV2ApplyButton = () => {
  const { isAutoRefreshOn } = useFiltersV2Select("isAutoRefreshOn");
  const { isFiltersBufferDirty, hasErrors } = useFiltersBufferState();
  const { applyBufferedFilters, toggleFiltersSidePanel } = useFiltersV2Actions();
  const { t } = useTranslation("filters");

  if (isAutoRefreshOn) {
    return null;
  }

  return (
    <Button
      title={t("applyAriaLabel")}
      onClick={() => {
        applyBufferedFilters();
        toggleFiltersSidePanel(false);
      }}
      disabled={!isFiltersBufferDirty || hasErrors}
    >
      {t("apply")}
    </Button>
  );
};
